import { AppConfigService } from "../../app_config/app_config_service.js";
import { maybeShowUpdateDialog } from "../../app_config/app_update_check.js";
import { ToClientCommand, ToServerCommand } from "../constants.js";
import { AppVersionResponse } from "../data_structures/to_client/app_version_response.js";
import { ServerController } from "../server_controller.js";
import { VersionLoader } from "../../version_loader.js";

export class AppVersionController
{
  private static readonly CONNECT_TIMEOUT_MS = 4_000;
  private static readonly RESPONSE_TIMEOUT_MS = 4_000;

  private static server: ServerController | null = null;
  private static pending_waiters: Array<() => void> = [];

  public static register( server: ServerController ): void
  {
    this.server = server;
    server.on( ToClientCommand.AppVersion, reader =>
    {
      const response = new AppVersionResponse();
      response.deserialize( reader );

      if ( !response.android )
      {
        console.warn( '[WebSocket] app-version message without android section' );
        return;
      }

      AppConfigService.setAppVersion( response.android, response.ios );
      const platform = ( window as any ).Capacitor?.getPlatform?.();
      const applied = platform === 'ios' ? AppConfigService.get().app_version.ios : AppConfigService.get().app_version.android;

      console.info( `[WebSocket] app-version: hard=${applied.hard} soft=${applied.soft}` );

      const waiters = this.pending_waiters.splice( 0 );
      waiters.forEach( resolve => resolve() );

      if ( waiters.length === 0 )
        maybeShowUpdateDialog( { allow_soft: false } );
    } );

    server.onReconnect( () => void this.request() );
  }

  public static async request(): Promise<boolean>
  {
    if ( !this.server ) return false;

    await VersionLoader.load();

    const connected = await this.server.waitForConnectionWithTimeout( this.CONNECT_TIMEOUT_MS );
    if ( !connected )
    {
      console.warn( '[WebSocket] app-version request skipped: connection timeout' );
      return false;
    }

    return this.server.sendRequest( null, ToServerCommand.AppVersion );
  }

  public static async requestAndWait(): Promise<boolean>
  {
    const sent = await this.request();
    if ( !sent ) return false;

    return new Promise<boolean>( resolve =>
    {
      const timer = setTimeout( () =>
      {
        this.pending_waiters = this.pending_waiters.filter( w => w !== on_received );
        console.warn( '[WebSocket] app-version response timeout' );
        resolve( false );
      }, this.RESPONSE_TIMEOUT_MS );

      const on_received = (): void =>
      {
        clearTimeout( timer );
        resolve( true );
      };

      this.pending_waiters.push( on_received );
    } );
  }
}
